import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { AuthComponent } from './shared/auth/auth.component';
import { AuthResolverService } from './shared/services/auth.resolver.service';
import { WelcomeAgentComponent } from './shared/welcome-agent/welcome-agent.component';
import { LoginComponent } from './shared/login/login.component';

const routes: Routes = [
   { path: 'welcome', component: LoginComponent },
   { path: 'welcome-agent', component: WelcomeAgentComponent },
   { path: 'auth', component: AuthComponent },
   { path: '', pathMatch: 'full', redirectTo: 'welcome-agent' },
   { path: '**', component: PageNotFoundComponent, resolve: {currentUser: AuthResolverService}}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
